import React from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp'
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import ReactMarkdown from 'react-markdown';
import OnVisible from 'react-on-visible';
import breaks from 'remark-breaks';
import { containers, Grid } from 'style';

class MailchimpFormComponent extends React.Component {

    constructor(){
        super();
        this.state = {
            sentstate: 0,
            name: '',
            email: '',
            company: '',
            role: '',
            responseText: '',
            submitable: false
        }

        this._handleChange = this._handleChange.bind(this);
        this._handleSubmit = this._handleSubmit.bind(this);
        this.checkSubmitable = this.checkSubmitable.bind(this);
    }
    
    _handleChange (e) {
        this.setState({
            [`${e.target.name}`]: e.target.value,
        }, this.checkSubmitable)
    }

    checkSubmitable(){
        this.setState({submitable: this.state.name !== '' && this.state.email !== '' && this.state.company !== ''});
    }

    _handleSubmit (e) {
        e.preventDefault()

        console.log('submit', this.state)

        this.setState({sentstate: 1, responseText: ''})

        addToMailchimp(this.state.email, this.state)
            .then(({ msg, result }) => {
                console.log('msg', `${result}: ${msg}`)

                if (result !== 'success') {
                    this.setState({sentstate: 0, responseText: msg})
                    throw msg
                }
                this.setState({sentstate: 2, responseText: this.props.thankYouText || 'Thank you', name: '', email: '', company: '', role: ''})
            })
            .catch(err => {
                console.log('err', err)
                this.setState({sentstate: 0, responseText: err})
                
            })
    }
  
    render () {

      const {title, body, file}  = this.props;
      const {sentstate, responseText, submitable}  = this.state;

      console.log(file)
      
      return (
        <div id="MailchimpFormComponent" className="container-fluid">
      <div className="row">
        <div className="col-xs-12">
            <Wrapper>
                <h2>{title}</h2>
                <p>{body}</p>
                {responseText && <p
                dangerouslySetInnerHTML={{
                    __html: responseText
                }}/>}
                {sentstate === 2 && file && <p>Open file: <a href={file.url} target={'_blank'} rel="noopener noreferrer">{file.title || file.filename}</a></p>}
            </Wrapper>
            </div>
        <div className="col-xs-12">
            <Wrapper>
                <Form onSubmit={this._handleSubmit} className={[sentstate === 2 ? 'submitted' : '', submitable ? 'submitable' : ''].join(' ')}>
                    <InputWrapper>
                    
                        <input
                            type="text"
                            onChange={this._handleChange}
                            placeholder="Name"
                            name="name"
                            required
                        />
                        <span>Name</span>
                    </InputWrapper>
                    <InputWrapper>
                        <input
                            type="email"
                            onChange={this._handleChange}
                            placeholder="E-mail"
                            name="email"
                            required
                        />
                        <span>E-mail</span>
                    </InputWrapper>
                    <InputWrapper>
                        <input
                            type="text"
                            onChange={this._handleChange}
                            placeholder="Company"
                            name="company"
                            required
                        />
                        <span>Company</span>
                    </InputWrapper>
                    <InputWrapper className="optional">
                        <input
                            type="text"
                            onChange={this._handleChange}
                            placeholder="Role"
                            name="role"
                            aria-required="false"
                        />
                        <span>Role</span>
                    </InputWrapper>
                    <br />
                    <div 
                        data-cursor="focus"
                        data-cursor-persistance="200">
                        <input type="submit" value="Subscribe >>" disabled={sentstate === 1} />
                    </div>
                </Form>
            </Wrapper>
            </div>
        </div>
        </div>
      )
    }
  }



export default MailchimpFormComponent;

const Wrapper = styled.div`
  width: 100%;

  max-width: 100%;
  @media (min-width: ${containers.ipad}px){
    max-width: ${props => props.leftAlignText ? '100%' : '44.5vw'};
  }
  margin: 0 auto;
`

const Form = styled.form`
  width: 100%;

  &.submitable {
    input[type=submit] {
        opacity: 1;
    }
  }

  input[type=submit] {
      border: 0;
      padding: .5rem 0;
      background: transparent;
      margin-left: auto;
      display: block;
      margin-top: 1.5rem;
      opacity: 0.5;
  }

  input[type=submit]:disabled {
      opacity: 0.5;
  }

  &.submitted {
      opacity: 0.5;
  }

`

const InputWrapper = styled.label`
    margin-bottom: 0.5rem;
    position:relative;
    display: block;
    width: 100%;
    span {
        position:absolute;
        top: 0;
        left: 0;
        transform: translateY(1.4rem);
        font-size: 1rem;
        opacity: 0.5;
        transition-duration: 300ms;
    }

    input {
        background: transparent;
        border: 0;
        border-bottom: 1px solid rgb(0 0 0 / 20%);
        height: 2em;
        padding:10px 0px;
        margin-top:20px;
        width: 100%;
    }
    input:not(:placeholder-shown) {
        border-bottom-color: #000;
    }
    input::placeholder{
        opacity:0;
    }

    &:focus-within > span,
    input:not(:placeholder-shown) + span,
    &:hover > span {
        transform: translateY(0px);
        font-size: 0.7rem;
    }

    &.optional:after {
        content: "Optional";
        display: block;
        position:absolute;
        top: 0;
        right: 0;
        transform: translateY(1.4rem);
        font-size: 0.7rem;
        opacity: 0.5;
    }
`;
